import { action } from 'typesafe-actions';

import * as Constants from './constants';
import * as Types from './types';

export const Entities = (args: Types.IAction.Entities) => action(Constants.ENTITIES, args);

export const List = {
  request: (args: Types.IAction.List.Request) => action(Constants.LIST.REQUEST, args),
  success: (args: Types.IAction.List.Success) => action(Constants.LIST.SUCCESS, args),
  failure: (args: Types.IAction.List.Failure) => action(Constants.LIST.FAILURE, args)
};

export const ListByApplicant = {
  request: (args: Types.IAction.ListByApplicant.Request) => action(Constants.LIST_BY_APPLICANT.REQUEST, args),
  success: (args: Types.IAction.ListByApplicant.Success) => action(Constants.LIST_BY_APPLICANT.SUCCESS, args),
  failure: (args: Types.IAction.ListByApplicant.Failure) => action(Constants.LIST_BY_APPLICANT.FAILURE, args)
};

export const ListByCategory = {
  request: (args: Types.IAction.ListByCategory.Request) => action(Constants.LIST_BY_CATEGORY.REQUEST, args),
  success: (args: Types.IAction.ListByCategory.Success) => action(Constants.LIST_BY_CATEGORY.SUCCESS, args),
  failure: (args: Types.IAction.ListByCategory.Failure) => action(Constants.LIST_BY_CATEGORY.FAILURE, args)
};

export const Info = {
  request: (args: Types.IAction.Info.Request) => action(Constants.INFO.REQUEST, args),
  success: (args: Types.IAction.Info.Success) => action(Constants.INFO.SUCCESS, args),
  failure: (args: Types.IAction.Info.Failure) => action(Constants.INFO.FAILURE, args)
};
